import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import FormLabel from '../../../library/form/components/FormLabel'
import FormDialog from '../../../library/form/components/FormDialog';
import FormTitle from '../../../library/form/components/FormTitle'
import FormROValue from '../../../library/form/components/FormROValue1';
import { UiCol, UiGridColOne, UiViewContent } from '../../../library/layout/Index';

const InvPaymentStatus = (props) => {
    const { formObject, viewData, ...restProps } = props;

    console.log("payment status", formObject);

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Close" } }}
            formStyle={{ height: '350px' }}
            contentStyle={{ height: '250px', width: "360px" }}
            formTitle={<FormTitle formObject={formObject} value='Payment Status' />}
            formObject={formObject} >
            <UiViewContent>
                <UiGridColOne>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refId" }} value="Odoo Reference ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "refId" }} className='uiVal' />
  
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "invName" }} value="Odoo Invoice Name" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "invName" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "paymentStatus" }} value="Payment Status" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "paymentStatus" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "amountResidual" }} value="Amount Outstanding" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "amountResidual" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "totalAmount" }} value="Total Amount" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "totalAmount" }} className='uiVal' />
                            </li>
                        </ul>
                    </UiCol>
                </UiGridColOne>
            </UiViewContent>

            <ul className="uiHeaderForm">
            </ul>
        </FormDialog>
    )
}

export default withView(InvPaymentStatus, "invPaymentStatus")